import { http } from '@/http'

export default {
  list(params)             { return http.get('/work-schedules', { params }) },
  listActive()             { return http.get('/work-schedules/active') },
  get(id)                  { return http.get(`/work-schedules/${id}`) },
  save(data)               { return http.post('/work-schedules', data) },
  update(id, data)         { return http.put(`/work-schedules/${id}`, data) },
  changeStatus(id, status) { return http.put(`/work-schedules/${id}/status?status=${status}`) },
  downloadBulkTemplate()   { return http.get('/work-schedules/template/xlsx', { responseType: 'blob' }) },
  uploadBulkExcel(file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post('/work-schedules/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
}
